// Time text of the Operations page. An instant is shown in UTC with the word "UTC": the browser zone is never an implicit input.

const INSTANT = new Intl.DateTimeFormat("en-GB", {
  timeZone: "UTC",
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

/** "17 Oct 2026, 14:03 UTC". An unreadable value is a dash, never "Invalid Date". */
export function formatInstant(value: Date | string | null | undefined): string {
  if (value === null || value === undefined) return "—";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return `${INSTANT.format(date)} UTC`;
}

/** "under a minute", "12 min", "5 h 10 min", "2 d 3 h". Data, not an SLA: it never judges. */
export function formatAge(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return "—";
  if (seconds < 60) return "under a minute";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return minutes % 60 === 0 ? `${hours} h` : `${hours} h ${minutes % 60} min`;
  const days = Math.floor(hours / 24);
  return hours % 24 === 0 ? `${days} d` : `${days} d ${hours % 24} h`;
}

/** The first eight characters of an id: enough to find it in the log, short enough for a table. */
export const shortId = (id: string): string => id.slice(0, 8);
